import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectBannersData, selectBannersError, selectIsBannersLoading } from '@lib/core/banners/selectors/banners';
import { actionGetBanners } from '@lib/core/banners/slices/banners';
import { TParsedBanner } from '@lib/core/banners/types';
import { ApiQueries } from '@lib/core/service/consts';
import { TBannerPositions } from '@lib/tools/shared/helpers/consts';
import { useTypedDispatch } from '@lib/tools/views/hooks/useTypedDispatch';

export const useBanners = ({ currentPosition }: { currentPosition: TBannerPositions }) => {
  const dispatch = useTypedDispatch();

  const bannersData = useSelector(selectBannersData);
  const isBannersLoading = useSelector(selectIsBannersLoading);
  const bannersError = useSelector(selectBannersError);

  const parsedBannersData: TParsedBanner[] = useMemo(
    () =>
      bannersData
        .map(banner => ({
          ...banner,
          // currentPosition indicates the banner click location for Mixpanel event
          currentPosition: banner.positions.find(({ identifier }) => identifier === currentPosition),
        }))
        .filter(banner => banner.currentPosition),
    [bannersData],
  );

  const fetchBannersByPosition = ({ position }: { position: TBannerPositions }) =>
    dispatch(
      actionGetBanners({
        [ApiQueries.positionsIdentifier]: position,
      }),
    );

  return {
    bannersError,
    fetchBannersByPosition,
    isBannersLoading,
    parsedBannersData,
  };
};
